module.exports = __webpack_public_path__ + "img/flagEgypt.1f3a78bd.svg";